import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    // Silently log to console for debugging; never surface a visible red error to the user.
    // eslint-disable-next-line no-console
    console.debug("[Bruno Courtin] ErrorBoundary caught:", error, info?.componentStack);
  }
  render() {
    if (this.state.hasError) {
      return (
        <section className="theme-ivory min-h-screen flex items-center justify-center px-6">
          <div className="max-w-lg text-center">
            <p className="eyebrow" style={{ color: "var(--copper)" }}>Erreur</p>
            <h1 className="font-display text-5xl mt-3 text-[var(--ink)]">Une page a rencontré un problème</h1>
            <p className="mt-6 text-[var(--brown)]/85">Merci de recharger la page ou de revenir à l'accueil.</p>
            <a href="/" className="btn-editorial filled mt-8 inline-flex">Retour à l'accueil</a>
          </div>
        </section>
      );
    }
    return this.props.children;
  }
}
